let url = 'http://localhost:8080';

if (process.env.REACT_APP_ENV == 'production') {
  url = 'https://api-demo.programadeexcelencia.com';
}

export default url;
